module.exports = __webpack_public_path__ + "static/media/canvaslms.ef1fdb96.jpg";